export const SW_DO_UPDATE = 'SW_DO_UPDATE'
export const _COMMIT_LOG = 'commitLog'
export const _PROCESS_ERROR = 'processAxiosError'
export const _DOWNLOAD_INVOICE = 'do_DOWNLOAD_INVOICE'

export const ACCT_GET_ACCOUNT = 'doACCT_GET_ACCOUNT'
export const ACCT_GET_ACCOUNT_BY_EXT_KEY = 'doACCT_GET_ACCOUNT_BY_EXT_KEY'
export const ACCT_ASSIGN_LOGIN = 'doACCT_ASSIGN_LOGIN'
export const ACCT_REMOVE_LOGIN = 'doACCT_REMOVE_LOGIN'
export const ACCT_ASSIGN_PLAN = 'doACCT_ASSIGN_PLAN'
export const ACCT_CHANGE_PLAN = 'doACCT_CHANGE_PLAN'
export const ACCT_REMOVE_PLAN = 'doACCT_REMOVE_PLAN'
export const ACCT_GET_ACCOUNT_ACTIVITY = 'doACCT_GET_ACCOUNT_ACTIVITY'
export const ACCT_GET_ACCOUNT_CORRESPONDENCES = 'doACCT_GET_ACCOUNT_CORRESPONDENCES'
export const ACCT_GET_ACCOUNT_FORMS = 'doACCT_GET_ACCOUNT_FORMS'
export const ACCT_GET_ACCOUNT_INVOICES = 'doACCT_GET_ACCOUNT_INVOICES'
export const ACCT_GET_ACCOUNT_PAYMENTS = 'doACCT_GET_ACCOUNT_PAYMENTS'
export const ACCT_GET_ACCOUNT_RATES = 'doACCT_GET_ACCOUNT_RATES'
export const ACCT_GET_ACCOUNT_SERVICES = 'doACCT_GET_ACCOUNT_SERVICES'
export const ACCT_GET_ACCOUNT_TICKETS = 'doACCT_GET_ACCOUNT_TICKETS'
export const ACCT_GET_ACCOUNT_USERS = 'doACCT_GET_ACCOUNT_USERS'
export const ACCT_GET_ACCOUNTS = 'doACCT_GET_ACCOUNTS'
export const ACCT_UPDATE_STMT_METH = 'doACCT_UPDATE_STMT_METH'
export const ACCT_UPDATE_CREDIT_CARD = 'doACCT_UPDATE_CREDIT_CARD'
export const ACCT_UPDATE_ECHECK = 'doACCT_UPDATE_ECHECK'
export const ACCT_POST_CHARGES = 'doACCT_POST_CHARGES'
export const ACCT_POST_PAYMENT_CC = 'doACCT_POST_PAYMENT_CC'
export const ACCT_POST_PAYMENT_ECHECK = 'doACCT_POST_PAYMENT_ECHECK'
export const ACCT_POST_PAYMENT_CASH = 'doACCT_POST_PAYMENT_CASH'
export const ACCT_POST_PAYMENT_CHECK = 'doACCT_POST_PAYMENT_CHECK'
export const ACCT_POST_PAYMENT_MONEYORDER = 'doACCT_POST_PAYMENT_MONEYORDER'
export const ACCT_POST_PAYMENT_VOID = 'doACCT_POST_PAYMENT_VOID'
export const ACCT_SEND_INVOICES = 'doACCT_SEND_INVOICES'

export const AUTH_LOGIN = 'doAuthLogin'
export const AUTH_LOGIN_OTP = 'doAuthLoginOtp'
export const AUTH_LOGOUT = 'doAuthLogout'

export const CUST_QUERY_RESULTS = 'doCUST_QUERY_RESULTS'

export const PUBLIC_IS_EMAIL_UNIQUE = 'doPublicIsEmailUnique'
export const PUBLIC_GET_PLANS = 'doPublicGetPlans'
export const PUBLIC_VERIFY_SMS_CODE = 'doPUBLIC_VERIFY_SMS_CODE'
export const PUBLIC_SEND_VERIFY_SMS = 'doPUBLIC_SEND_VERIFY_SMS'
export const PUBLIC_VERIFY_EMAIL_CODE = 'doPUBLIC_VERIFY_EMAIL_CODE'
export const PUBLIC_SEND_VERIFY_EMAIL = 'doPUBLIC_SEND_VERIFY_EMAIL'
export const PUBLIC_PROCESS_GOOGLE_PLACE = 'doPublicProcessPlace'
export const PUBLIC_REGISTER_USER = 'doPublicRegisterUser'
export const PUBLIC_COMMIT_PASSWORD_RESET = 'doPUBLIC_COMMIT_PASSWORD_RESET'
export const PUBLIC_REQUEST_PASSWORD_RESET = 'doPUBLIC_REQUEST_PASSWORD_RESET'

export const PLAN_GET_PLANS = 'doPLAN_GET_PLANS'
export const PLAN_PROCESS_PLANS = 'doPLAN_PROCESS_PLANS'

export const SEARCH_POST_QUERY = 'doSEARCH_POST_QUERY'
export const SEARCH_POST_QUERY_CSV = 'doSEARCH_POST_QUERY_CSV'

export const SIGNUP_GET_PLANS_AVAIL = 'doSignupGetPlansAvail'
export const SIGNUP_CHECK_STATUS = 'doSIGNUP_CHECK_STATUS'
export const SIGNUP_CONFIRM_SIGNUP = 'doSIGNUP_CONFIRM_SIGNUP'
export const SIGNUP_SUBMIT_EZ_SIGNUP = 'doSIGNUP_SUBMIT_EZ_SIGNUP'

export const TOWER_GET_TOWERS = 'doTOWER_GET_TOWERS'
export const TOWER_GET_APS = 'doTOWER_GET_APS'
export const TOWER_GET_SUBS = 'doTOWER_GET_SUBS'

export const USER_GET_USERS = 'doUSER_GET_USERS'
export const USER_SET_STAFF = 'doUSER_SET_STAFF'

export const FORM_GET_FORMS = 'doFORM_GET_FORMS'

export const FORM_RESULT_GET = 'doFormResultGet'
export const FORM_RESULT_GET_MANY = 'doFormResultGetMany'
export const FORM_RESULT_UPDATE_PROCESSED = 'doFormResultUpdateProcessed'
export const FORM_RESULT_CREATE_PLAT_CUST = 'doFORM_RESULT_CREATE_PLAT_CUST'
export const FORM_RESULT_MARK_PROCESSED = 'doFORM_RESULT_MARK_PROCESSED'
export const FORM_RESULT_VWCONFIRM_SIGNUP = 'doFORM_RESULT_VWCONFIRM_SIGNUP'
